import { useRef, useEffect } from 'react'

export const getClassName = (s) => {
  if (s != null) {
    return s.replace(/[^\w]/gi, '_').toLowerCase()
  }

  return ''
}

export const announceForScreenReader = (s) => {
  document.getElementById('screen_reader_announce').innerHTML = s
  return true
}

export const trimSpaces = (s) => {
  // Check s is a string
  if (typeof s !== 'string') {
    return s
  }
  return s?.replace(/(?:^[\s\u00a0]+)|(?:[\s\u00a0]+$)/g, '')
}

export const getNodeText = (node) => {
  if (['string', 'number'].includes(typeof node)) return node
  if (node instanceof Array) return node.map(getNodeText).join('')
  if (typeof node === 'object' && node) return getNodeText(node.props.children)
}

export const useOnUpdate = (callback, deps) => {
  const isFirst = useRef(true)
  useEffect(() => {
    if (!isFirst.current) {
      callback()
    }
  }, deps)

  useEffect(() => {
    isFirst.current = false
  }, [])
}
